import React, { useState, useEffect } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import "./dashboard.scss";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import Environment from "utils/environment";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import EditProduct from "views/Product/EditProduct";
import { border } from "@mui/system";

function Dashboard() {
  const [show1, setShow1] = useState(false);
  const [show, setShow] = useState(false);
  const val = localStorage.getItem("accessToken");
  const api_url = Environment.base_url;
  const BASE_URL = Environment.base_url99;

  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [categoriesData, setCategoriesData] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [opType, setOpType] = useState("");
  const [editId, setEditId] = useState("");
  const [pageCount, setPageCount] = useState([]);
  const [offset, setOffset] = useState(1);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [orderList, setOrderList] = useState([]);
  const [orderStats, setOrderStats] = useState([]);
  const [limit, setLimit] = useState(10);
  const url = api_url + "/store/categories/";
  const [searchQuery, setSearchQuery] = useState("");
  const [searchBy, setSearchBy] = useState("name");
  const [currentView, setCurrentView] = useState(false);
  const [currentView1, setCurrentView1] = useState(true);
  const [activeFilter, setActiveFilter] = useState("none");
  const [availableProducts, setAvailableProducts] = useState([]);
  const [outOfStockProducts, setOutOfStockProducts] = useState([]);
  const [selectedStockTab, setSelectedStockTab] = useState(null);
  const [isRotating, setIsRotating] = useState(false);
  const [isClickable, setIsClickable] = useState(true);
  const [isBlack, setIsBlack] = useState(false);
  const [syncing, setsyncing] = useState('');
  const [orderStatsnew, setOrderStatsnew] = useState({ stock: 0, outStock: 0 });



  const FetchRefreshToken = async () => {
    localStorage.removeItem("accessToken");
    let refreshVal = localStorage.getItem("refreshToken");
    var config = {
      method: "post",
      url: api_url + `/auth/admins/refresh-token`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { refreshToken: refreshVal },
    };
    await axios(config)
      .then(function (response) {
        localStorage.removeItem("refreshToken");
        console.log(response.data.data);
        localStorage.setItem("accessToken", response.data.data.accessToken);
        localStorage.setItem("refreshToken", response.data.data.refreshToken);
        history.push("/admin/dashboard");
      })
      .catch(function (error) {
        console.log(error);
         if (error.response.data.status === 400) {
          console.log(error);
        } else if (error.response.data.status === 401) {
          toast.error("Jwt expired/invalid", {
            position: "top-right",
            autoClose: 3000,
          });
          history.push("/");
        } else if (error.response.data.status === 403) {
          toast.error("403", {
            position: "top-right",
            autoClose: 3000,
          });
        } else if (error.response.data.status === 404) {
          toast.error("Whitelisted user not found", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      });
  };
   
  const productstore = async () => {
    try {
      const response = await axios.get(`${api_url}/store/products/admin-products?limit=${limit}&offset=${offset}&`, {
        headers: {
          Authorization: "Bearer " + val,
        },
      });
      setCount(response.data.data.count);
      console.log("Products Data:", response.data.data.products);
      setCategoriesData(response.data.data.products);
      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setPage(response.data.data.pages);
      const products = response.data.data.products;
      const available = products.filter((p) => p.quantity > 1);
      const outOfStock = products.filter((p) => p.quantity === 0);
      setAvailableProducts(available);
      console.log(available, 'availableavailableavailableavailableavailable')
      setOutOfStockProducts(outOfStock);
      setPageCount(arr);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  const isPublish = async () => {

    if (activeFilter === 'published') {
      setActiveFilter('none');
      productstore();
      return;
    }
    setActiveFilter('published');
    setLoader(true);
    setCategoriesData([]);
    try {
      const response = await axios.get(
        `${BASE_URL}/admin-products?limit=${limit}&offset=${offset}&filter=isPublish=eq:true`,
        {
          headers: {
            Authorization: "Bearer " + val,
          },
        }
      );
      const resData = response?.data?.data?.products
      console.log("Products Data:", resData);
      setCategoriesData(resData);
      setCount(response.data.data.count);
      console.log("Products Data:", response.data.data.products);
      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setPage(response.data.data.pages);
      setPageCount(arr);
      setLoader(false);
      if (response?.data?.data?.products?.[0]?.isPublish === true) {
        setCurrentView(response?.data?.data?.products?.[0]?.isPublish)

      }

    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 501) {
        localStorage.removeItem("accessToken");
        history.push("/");
      }
      console.error("Error fetching order stats:", error);
    }
  }
  const isnotPublish = async () => {

    if (activeFilter === 'unpublished') {
      setActiveFilter('none');
      productstore();
      return;
    }
    setActiveFilter('unpublished');
    setLoader(true);
    setCategoriesData([]);

    try {
      const response = await axios.get(
        `${BASE_URL}/admin-products?limit=${limit}&offset=${offset}&filter=isPublish=eq:false`,
        {
          headers: {
            Authorization: "Bearer " + val,
          },
        }
      );
      const resData = response?.data?.data?.products
      console.log("Products Data:", resData);
      setCategoriesData(resData);
      setCount(response.data.data.count);
      console.log("Products Data:", response.data.data.products);
      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setPage(response.data.data.pages);
      setPageCount(arr);
      setLoader(false);
      if (response?.data?.data?.products?.[0]?.isPublish === false) {
        setCurrentView1(response?.data?.data?.products?.[0]?.isPublish)

      }

    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 501) {
        localStorage.removeItem("accessToken");
        history.push("/");
      }
      console.error("Error fetching order stats:", error);
    }
  }
  const publishUnpublishProduct = async (id) => {
     const config = {
      method: "patch",
      url: api_url + "/store/products/" + id + "/is-publish",
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    await axios(config)
      .then((res) => {
       })
      .catch((err) => {
        if (err?.response?.status == 501) {
          history.push("/");
        } else {
          console.log("error meessage: ", err?.response?.data?.message);
          toast.error(err?.response?.data?.message, {
            position: "top-right",
            autoClose: 2000,
          });
        }
        setLoader(false);
      });
  };
  const getOrderStats = async () => {
    setLoader(true);
    setOrderStats([]);
    try {
      const response = await axios.get(
        `${BASE_URL}/product/stats`,
        {
          headers: {
            Authorization: "Bearer " + val,
          },
        }
      );
      const resData = response?.data?.data;
      console.log(response?.data?.data?.syncing?.updatedAt, 'syncingsyncingsyncingsyncing ')
      setsyncing(response.data.data.syncing?.updatedAt);
      setOrderStats(resData);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 501) {
        localStorage.removeItem("accessToken");
        history.push("/");
      }
      console.error("Error fetching order stats:", error);
    }
  }
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchQuery.trim().length > 0) {
        searchProducts();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, searchBy]);

  useEffect(() => {
    if (searchQuery.trim().length === 0) {
      productstore();
    }
  }, [searchQuery]);

  const searchProducts = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/admin-products?limit=100&offset=1&search=${searchBy}=${encodeURIComponent(searchQuery)}`
      );
      setCategoriesData(response?.data?.data?.products);
      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setPage(response.data.data.pages);
      setPageCount(arr);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (!val) {
      history.push("/");
    } else {
      productstore()
      getOrderStats();

    }
  }, [offset]);



  const fetchInStockProducts = async () => {
    if (activeFilter === 'fetchInStockProducts') {
      setActiveFilter('none');
      productstore();
      return;
    }
    setActiveFilter('fetchInStockProducts');
    setLoader(true);
    setCategoriesData([]);

    try {
      const response = await axios.get(
        `${BASE_URL}/admin-products?limit=100&offset=1&filter=quantity=gt:0`,
        {
          headers: {
            Authorization: "Bearer " + val,
          },
        }
      );
      const products = response?.data?.data?.products || [];
      setCategoriesData(products);
      setCount(response?.data?.data?.count || 0);
      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setPage(response.data.data.pages);
      setPageCount(arr);
    } catch (error) {
      console.error("Error fetching in-stock products:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchOutOfStockProducts = async () => {
    if (activeFilter === 'fetchOutOfStockProducts') {
      setActiveFilter('none');
      productstore();
      return;
    }
    setActiveFilter('fetchOutOfStockProducts');
    setLoader(true);
    setCategoriesData([]);

    try {
      const response = await axios.get(
        `${BASE_URL}/admin-products?limit=100&offset=1&filter=quantity=lte:0`,
        {
          headers: {
            Authorization: "Bearer " + val,
          },
        }
      );
      const products = response?.data?.data?.products || [];
      setCategoriesData(products);
      setCount(response?.data?.data?.count || 0);

      let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
      setPage(response.data.data.pages);
      setPageCount(arr);
    } catch (error) {
      console.error("Error fetching out-of-stock products:", error);
    } finally {
      setLoader(false);
    }
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return "N/A"; 

    const syncTime = new Date(dateString);
    if (isNaN(syncTime)) {
      console.log("Invalid Date:", dateString);
      return "Invalid Date";
    }

    const now = new Date();
    const diffMs = now - syncTime;
    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (minutes < 1) return "just now";
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    return `${days} day${days > 1 ? "s" : ""} ago`;
  };


  const handleClick = () => {
    if (!isClickable) return;

    setIsRotating(true);
    setIsClickable(false);
    setIsBlack(false);

    setTimeout(() => {
      setIsRotating(false);
      setIsBlack(true);
    }, 3000);

    setTimeout(() => {
      setIsClickable(true);
      setIsBlack(false);
    }, 30000);
  }
  return (
    <>
      <div className="content">
        <section className="main-dashboard">
          <div className="row">
            <div className="col-sm-12 p-0">
              <div className="Overview_main">
                <div className="headerleftmain">

                  <h4 className="headdingg">Products</h4>
                   <p className="headermaianchld">
                    Last sync : <span>{syncing ? getTimeAgo(syncing) : "N/A"}</span>
                    <svg
                      onClick={handleClick}
                      className={`svgmain ${isRotating ? "rotate" : ""}`}
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      style={{ cursor: isClickable ? "pointer" : "not-allowed" }}
                    >
                      <path
                        d="M1.99948 9.39226C2.14948 9.39226 2.29798 9.32526 2.39598 9.19726L2.61348 8.91476C2.93898 10.8458 4.29148 12.4978 6.21148 13.1643C6.80248 13.3693 7.40898 13.4678 8.00748 13.4678C9.79948 13.4678 11.524 12.5838 12.5565 11.0273C12.709 10.7973 12.646 10.4868 12.416 10.3343C12.185 10.1808 11.876 10.2448 11.7225 10.4748C10.598 12.1718 8.46648 12.8898 6.53998 12.2198C4.94148 11.6648 3.82648 10.2733 3.58848 8.65726L4.01648 8.98676C4.23598 9.15426 4.54948 9.11426 4.71748 8.89526C4.88598 8.67626 4.84548 8.36276 4.62648 8.19426C4.62648 8.19426 3.44398 7.28376 3.44098 7.28176C3.19248 7.09026 2.83898 6.98276 2.61398 7.27626L1.60398 8.58776C1.43548 8.80676 1.47598 9.12026 1.69498 9.28876C1.78548 9.35826 1.89298 9.39226 1.99948 9.39226Z"
                        fill={isBlack ? "#757575" : "#009DE0"}
                      />
                      <path
                        d="M3.58444 5.66502C3.81394 5.81752 4.12444 5.75452 4.27794 5.52452C5.40244 3.82802 7.53594 3.11002 9.46044 3.77952C11.0589 4.33452 12.1739 5.72602 12.4119 7.34202L11.9839 7.01252C11.7644 6.84452 11.4509 6.88452 11.2829 7.10402C11.1144 7.32302 11.1549 7.63652 11.3739 7.80502C11.3739 7.80502 12.5564 8.71502 12.5594 8.71752C12.8124 8.91202 13.1579 9.02102 13.3864 8.72302L14.3964 7.41152C14.5649 7.19252 14.5244 6.87902 14.3054 6.71052C14.0864 6.54202 13.7724 6.58302 13.6044 6.80202L13.3869 7.08452C13.0614 5.15352 11.7089 3.50152 9.78894 2.83502C7.42894 2.01602 4.82094 2.89452 3.44394 4.97152C3.29144 5.20202 3.35444 5.51202 3.58444 5.66502Z"
                        fill={isBlack ? "#757575" : "#009DE0"}
                      />
                     </svg>
                  </p>
 
                </div>
                <div className="innerheaderdashborad">

                  <div className="search-field w-100">
                    <img
                      src="\nav-assets\search-normal.svg"
                      alt="img"
                      className="search-icon"
                    />

                    <input
                      type="text"
                      placeholder="Search"
                      className="parent-input"
                      value={searchQuery}
                      onChange={(e) =>
                        setSearchQuery(
                          e.target.value.replace(/\+/g, "%2B").replace(/&/g, "%26")
                        )
                      }
                    />
                    <div class="dropdown dropdown-text-parent">
                      <h6
                        className="dropdown-text"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        By {searchBy === 'name' ? 'Name' : searchBy === 'sourceProductId' ? 'Barcode/ID' : ''}
                        <img
                          src="\assestsss\arrow1.svg"
                          alt="img"
                          className="img-fluid ml-1"
                        />
                      </h6>

                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <div className="input-field">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="searchBy"
                            value="name"
                            id="byName"
                            checked={searchBy === "name"}
                            onChange={() => setSearchBy("name")}
                          />
                          <label htmlFor="byName">By name</label>
                        </div>
                        <div className="input-field  inputlastfieldss">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="searchBy"
                            value="sourceProductId"
                            id="byBarcode"
                            checked={searchBy === "sourceProductId"}
                            onChange={() => setSearchBy("sourceProductId")}
                          />
                          <label htmlFor="byBarcode">Barcode/ID</label>
                        </div>

                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div className="row "  >

                <div className={`col-xl-3 col-lg-6 col-md-6 col-sm-12 pl-0 padd-l padd `}
                  onClick={isPublish}
                  style={{ cursor: "pointer" }}
                >
                  <div className="carddashbord">

                    <div
                      className="carrdmainflex"
                      onClick={isPublish}
                      
                      style={{
                        border: activeFilter === 'published' ? '2px solid #009DE0' : '', 
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      <div className="cardpic">
                        <img src="\Products\Published.svg" alt="img" />
                      </div>
                      <div className="cardpichnd">
                        <p className="headdinggfst">Published</p>
                           <p className="headdinggfstdd">{orderStats?.publish}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 padd-r padd"
                  onClick={isnotPublish}
                  style={{ cursor: "pointer" }}
                >
                  <div className="carddashbord">
                    <div className="carrdmainflex"
                    
                      style={{
                        border: activeFilter === 'unpublished' ? '2px solid #009DE0' : '', 
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      <div className="cardpic">
                        <img
                          src="\Products\unpublished.svg"
                          alt="img"
                          className=""
                        />
                      </div>
                      <div className="cardpichnd">
                        <p className="headdinggfst">Unpublished</p>
                      
                          <p className="headdinggfstdd">
                           {orderStats?.unPublish}
                          </p>
                       
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="col-xl-3 col-lg-6 col-md-6 col-sm-12 padd thrdpadd"
                  onClick={fetchInStockProducts}
                >
                  <div className="carddashbord">
                    <div className="carrdmainflex"
                      style={{
                        border: activeFilter === 'fetchInStockProducts' ? '2px solid #009DE0' : '', 
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      <div className="cardpic">
                        <img src="/dashbord/cardthrd.svg" alt="img" />
                      </div>
                      <div className="cardpichnd">
                        <p className="headdinggfst">In-Stock</p>
                        <p className="headdinggfstdd">{orderStats?.stock}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Out of Stock Card */}
                <div
                  className="col-xl-3 col-lg-6 col-md-6 col-sm-12 pr-0 padd-r padd"
                  onClick={fetchOutOfStockProducts}
                  style={{ cursor: "pointer" }}
                >
                  <div className="carddashbord">
                    <div className="carrdmainflex"
                      style={{
                        border: activeFilter === 'fetchOutOfStockProducts' ? '2px solid #009DE0' : '',
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      <div className="cardpic">
                        <img src="/dashbord/cardfor.svg" alt="img" />
                      </div>
                      <div className="cardpichnd">
                        <p className="headdinggfst">Out of Stock</p>
                        <p className="headdinggfstdd">{orderStats?.outStock}</p>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <div className="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">PRODUCT NAME</th>
                      <th scope="col">CATEGORY</th>
                      <th scope="col">PRICE</th>
                      <th scope="col">STOCK</th>
                      <th scope="col">STATUS</th>
                      <th scope="col">PUBLISH</th>
                      <th scope="col">ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoriesData.length > 0 ? (
                      categoriesData.map((item, index) => {
                        return (
                          <>
                            <tr>
                              <td className="id">{item?.sourceProductId}</td>
                              <td>
                                <img
                                  src={item?.imageUrl}
                                  alt="img"
                                  className="img-fluid mr-2 cat-img cat__image"
                                />{" "}
                                {item?.name}

                              </td>
                              <td>
                                <div className="switch-input">

                                  {/* Baby Care */}
                                  {item?.category[0]?.name || "N/A"}

                                </div>
                              </td>
                              <td>
                                <div className="switch-input">

                                  {item?.price}
                                </div>
                              </td>
                              <td>
                                <div className="switch-input">

                                  {item?.quantity}
                                </div>
                              </td>
                              <td>
                                <div className="switch-input">
                                  <p
                                    className="innerpending"
                                    style={{
                                      background:
                                        item?.quantity <= item?.outOfStockThreshold ? "#E15151" : "",
                                    }}
                                  >
                                    {item?.quantity > item?.outOfStockThreshold
                                      ? `In-Stock (${item?.quantity})`
                                      : `Out of Stock (${item?.quantity})`}
                                  </p>
                                </div>

                              </td>
                                <td>
                                <div className="switch-input">
                                  <input
                                    class="tgl tgl-ios"
                                    id={(index + offset).toString()}
                                    type="checkbox"
                                    defaultChecked={item?.isPublish}
                                    onChange={() =>
                                      publishUnpublishProduct(item?.id)
                                    }
                                  />
                                  <label
                                    class="tgl-btn"
                                    for={(index + offset).toString()}
                                  ></label>
                                </div>
                              </td>


                              <td>
                                <a
                                  onClick={() => {
                                    setShow(true);
                                    setOpType("edit");
                                    setEditId(item?.id);
                                  }}
                                >
                                  <img
                                    src="\users-assets\edit-icon.svg"
                                    alt="img"
                                    className="img-fluid mr-2"
                                  />
                                </a>
                               
                              </td>
                            </tr>
                          </>
                        );
                      })
                    ) : loader ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          <div className="text-center">
                            {<Spinner animation="border" variant="info" />}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <p style={{
                        color: 'white',
                        padding: '15px'
                      }}>No Records</p>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="mainfoot">
                <div className="left">
                  {count > 0 && count <= limit ? (
                    <>
                      <p>
                        SHOWING 1-{count} OF {count}
                      </p>
                    </>
                  ) : count > limit ? (
                    <>
                      <p>
                        SHOWING{" "}
                        {offset > 1 ? (offset - 1) * limit + 1 : offset} -
                        {limit * offset > count ? count : limit * offset} OF{" "}
                        {count}
                      </p>
                    </>
                  ) : (
                    <>
                      <p>SHOWING 0 OF 0</p>
                    </>
                  )}
                </div>
                <div className="right">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination">
                      <Stack spacing={2}>
                        <Pagination
                          count={page}
                          page={offset}
                          onChange={(e, p) => setOffset(p)}
                          color="primary"
                        />
                      </Stack>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </section>
        <EditProduct
          show={show}
          setShow={setShow}
          updateList={productstore}
          editId={editId}
          setEditId={setEditId}
        />
      </div>
    </>
  );
}
export default Dashboard;
